import React from "react";
import Navbar from "../../../Common/Components/Navbar";
import Footer from "../../../Common/Components/Footer";
import Sidebar from "../../../Sidebar/Sidebar";
import EditUserComp from "./Component/EditUserComp"

const EditUser =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditUserComp />
        </div>
        <Footer />
        </>
    )
}

export default EditUser

